import { TypographyThemeType } from './theme.types';

export const typographiesTheme: TypographyThemeType = {
  fontFamily: ['-apple-system', 'DM Sans', 'sans-serif'].join(','),
  h1: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.6,
    letterSpacing: '0.0075em',
  },
  h2: {
    fontSize: 18,
    fontWeight: 700,
  },
  h3: {
    fontSize: 18,
    fontWeight: 500,
  },
  h4: {
    fontSize: 35,
    fontWeight: 700,
  },
  h5: {
    fontSize: 14,
    fontWeight: 700,
  },
  h6: {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.5,
    whiteSpace: 'normal',
    textTransform: 'none',
  },
  subtitle1: {
    fontSize: 12,
  },
  subtitle2: {
    fontSize: 15,
  },
  body1: {
    fontSize: 14,
    fontWeight: 500,
  },
  body2: {
    fontSize: 15,
    fontWeight: 500,
  },
};
